// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__JGHFS","input":"Input_input__7s5ug","large":"Input_large__0tlx8","inputNumber":"Input_inputNumber__g6Z6J"};